import { render } from "./ToolConsumption.vue?vue&type=template&id=c00b8d6a"
import script from "./ToolConsumption.vue?vue&type=script&lang=js"
export * from "./ToolConsumption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__